import { configureStore } from '@reduxjs/toolkit';
import SendErrorToRaygunMiddleware from '../../Common/Redux/SendErrorToRaygunMiddleware';
import { setupListeners } from '@reduxjs/toolkit/query';
import rateAuditPageViewReducer from '../RateCard/RateAuditPageViewSlice';
import rateCardPageViewReducer from '../RateCard/RateCardPageViewSlice';
import { defaultMiddlewareConfiguration } from "../../Common/Redux/ReduxMiddleware";

export const store = configureStore({
    reducer: {
        rateAuditPageView: rateAuditPageViewReducer,
        rateCardPageView: rateCardPageViewReducer
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware(defaultMiddlewareConfiguration).concat(SendErrorToRaygunMiddleware);
    }
});

setupListeners(store.dispatch);

export type RatesDespatch = typeof store.dispatch;
export type RatesRootState = ReturnType<typeof store.getState>;
